import React, { memo } from "react";
import { FormProvider } from "react-hook-form";
import { Layout, Flex } from "../../../components/Layout";
import Icon from "../../../components/Icon";
import { formControls } from "../constants/forms";
import { isInvalid, inputMaxLengthHelpers } from "../../../libs/helpers/forms";
import ErrorsMessages from "../../../components/ErrorsMessages";
import { INPUT_NATURAL_NUMERIC_KEYCODES } from "../../../constants/keycodes";
import SpacingBox from "../../../components/SpacingBox";
import AdditionalCustomerFields from "./AdditionalCustomerFields";
import useQuotationForm from "../hooks/useQuotationForm";
import SectionFieldsWhichEnsure from "./SectionFieldsWhichEnsure";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { PHONE } from "../../../libs/helpers/regex";
import "../styles/QuotationForm.css";
import { ContactConsentCheckbox } from "./ContactConsentCheckbox";
import Button from "../../../components/Button/Button";
import TextField from "../../../components/textfield/textfield";
import cellPhoneIcon from '../../../assets/images/icons/cell-phone.svg';
import dniIcon from '../../../assets/images/icons/dni.svg';
import mailIcon from '../../../assets/images/icons/mail.svg';

const QuotationForm = () => {
    const {
        rhForm,
        handleOnSubmit,
        handleDocumentNumberBlur,
        documentExists,
        validating,
        isCustomerDocumentIdInvalid,
        submitting,
    } = useQuotationForm();

    const {
        getValues,
        formState: { isValid },
    } = rhForm;
    console.log(getValues('clientType'))

    return (
        <FormProvider {...rhForm}>
            <form
                className="quotation-form"
                onSubmit={handleOnSubmit}
                data-testid="QuotationForm"
            >
                <Layout align="center" mb="30">
                    <SpacingBox cmp={Flex} flex={1}>
                        <h3 className="text-secondary" text-align="center">
                            Ingresa tus datos y nos contactaremos
                            <br /> contigo
                        </h3>
                    </SpacingBox>
                </Layout>
                <label
                    htmlFor={formControls.documentNumber.key}
                    className="form-control__label"
                >
                    <b>{formControls.documentType.label}</b>
                </label>
                <Layout>
                    <Flex flex={1}>
                        <TextField
                            data-testid={formControls.documentType.key}
                            fluid
                            readOnly
                            name={formControls.documentType.key}
                            icon={<Icon name="dni" image={dniIcon} />}
                        />
                    </Flex>
                    <Flex flex={1}>
                        <TextField
                            fluid
                            isNumeric
                            inputMode="tel"
                            maxLength={8}
                            loading={validating}
                            onBlur={handleDocumentNumberBlur}
                            placeholder={formControls.documentNumber.placeholder}
                            name={formControls.documentNumber.key}
                        />
                    </Flex>
                </Layout>
                <AdditionalCustomerFields hidden={documentExists} />
                <SectionFieldsWhichEnsure />
                <label
                    htmlFor={formControls.cellphone.key}
                    className="form-control__label"
                >
                    <b>{formControls.cellphone.label}</b>
                </label>
                <Layout>
                    <Flex flex="0 0 50%">
                        <TextField
                            fluid
                            isNumeric
                            inputMode="tel"
                            placeholder={formControls.cellphone.placeholder}
                            name={formControls.cellphone.key}
                            maxLength={9}
                            icon={<Icon name="cell-phone" image={cellPhoneIcon} />}
                        />
                    </Flex>
                </Layout>
                <label htmlFor={formControls.email.key} className="form-control__label">
                    <b>{formControls.email.label}</b>
                </label>
                <TextField
                    type="text"
                    inputMode="email"
                    autoComplete="off"
                    fluid
                    placeholder={formControls.email.placeholder}
                    name={formControls.email.key}
                    icon={<Icon name="mail" image={mailIcon} />}
                    maxLength={100}
                />
                <SpacingBox mt="30">
                    <ContactConsentCheckbox />
                </SpacingBox>
                <SpacingBox mt="50" className="text-center">
                    <Button
                        type="submit"
                        id="btnQuote"
                        disabled={
                            validating ||
                            submitting ||
                            !isValid ||
                            isCustomerDocumentIdInvalid
                        }
                        className="rounded"
                        fluid
                    >
                        Continuar
                    </Button>
                </SpacingBox>
                <LoadingOverlay show={submitting} />
            </form>
        </FormProvider>
    );
};

export default memo(QuotationForm);
